// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"HubTile_tabsContainer__2ZoD0","tab":"HubTile_tab__g-994","tabIcon":"HubTile_tabIcon__1CSQN"};